export default "__VITE_ASSET__CT_eM2eA__"